import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeFromCart } from '../../api/apiStorefront';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useRemoveFromCart = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (itemId) => removeFromCart(itemId),
    onSuccess: () => {
      toast.success(t('cart.removeSuccess', 'Item removed from cart!'));
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['cart-count'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || t('cart.removeError', 'Failed to remove item from cart');
      toast.error(message);
    },
  });
};
